const apiUrl = process.env.REACT_APP_API_URL;
export const PostUsuari = async ( id : number | null, nom : string, pass : string , page : string, id_usu_log : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id, nom, pass})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
